import { render } from "./SelectCompanyForOrder.vue?vue&type=template&id=cbf63cea&scoped=true"
import script from "./SelectCompanyForOrder.vue?vue&type=script&lang=js"
export * from "./SelectCompanyForOrder.vue?vue&type=script&lang=js"

import "./SelectCompanyForOrder.vue?vue&type=style&index=0&id=cbf63cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf63cea"]])

export default __exports__